export default function propertyPhotoPath() {
  return process.env.REACT_APP_STAGE === "local"
    ? "http://localhost:8080/api/property/image/"
    : process.env.REACT_APP_STAGE === "production"
    ? "https://my.noxio.app/api/property/image/"
    : "";
}
